import React from 'react';

import TwoWayToggle from '../../../Common/TwoWayToggle/index';

const CumulativeAbsoluteToggle = ({ value, onChange }) => <TwoWayToggle
  option1="cumulative"
  label1="Cumulative"
  option2="absolute"
  label2="Absolute"
  value={value}
  onChange={onChange}
/>;

export default CumulativeAbsoluteToggle;


// WEBPACK FOOTER //
// ./src/components/Reports/JobReport/toggles/CumulativeAbsoluteToggle.js